/*
 * Small organ glyphs used on the redrawn report pages (heart, lungs, liver,
 * kidneys, thyroid, stomach). Simple filled or outlined shapes on a 24-unit
 * grid, coloured by `color`. Always decorative: aria-hidden, next to text.
 */

const SHAPES = {
  heart: [
    'M12 21c-4-2.6-8-6.2-8-10.6C4 7.5 6 5.5 8.6 5.5c1.4 0 2.6.6 3.4 1.6.8-1 2-1.6 3.4-1.6C18 5.5 20 7.5 20 10.4 20 14.8 16 18.4 12 21Z',
    'M10 6.2V2.8M13.2 6.6V2.4M15.6 6l1.8-2.6',
  ],
  lungs: [
    'M10.6 8.4C8.2 7 5.2 9.2 4.6 13.2s-.4 7 2 7.4 4-1.6 4-4.6Z M13.4 8.4c2.4-1.4 5.4.8 6 4.8s.4 7-2 7.4-4-1.6-4-4.6Z',
    'M12 3v7M12 9l-1.6 2M12 9l1.6 2',
  ],
  liver: ['M3 9.4C6.2 6.4 13 5.4 19 6.2c2.2.3 2.8 2.1 1.7 3.7-2 3.2-6.8 7-11.8 8.1-3.2.7-5.9-1.3-5.9-4.6Z', ''],
  kidney: [
    'M8.2 4C5.2 4 3.6 7.2 4 11.2s2 8 5 8c2 0 2.6-2 2-4-.4-1.6-1.6-2.4-1.4-4 .2-1.6 1.4-2.2 1.4-4S9.8 4 8.2 4Z M15.8 4c3 0 4.6 3.2 4.2 7.2s-2 8-5 8c-2 0-2.6-2-2-4 .4-1.6 1.6-2.4 1.4-4-.2-1.6-1.4-2.2-1.4-4S14.2 4 15.8 4Z',
    '',
  ],
  thyroid: ['M12 8.4C11 5.2 5.8 4.4 4.8 8.2S5.6 17.4 8.8 17.4c2 0 2.6-2 3.2-4 .6 2 1.2 4 3.2 4 3.2 0 5-5.4 4-9.2S13 5.2 12 8.4Z', ''],
  stomach: ['M9 3v4.2c0 2-4.2 3-4.2 8 0 4 3.2 6 7.2 6s7.2-2 7.2-5.2-3-4.2-5-3.2-3 1-3-1.2V3Z', ''],
};

export default function Organ({ name, size = 20, color = 'currentColor', outline = false, className }) {
  const [body, detail] = SHAPES[name];
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill={outline ? 'none' : color}
      stroke={color}
      strokeWidth={outline ? 1.8 : 0.6}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d={body} />
      {detail && <path d={detail} fill="none" strokeWidth={outline ? 1.8 : 1.6} />}
    </svg>
  );
}
